import { c as _c } from "react/compiler-runtime";
import { ChangeOriginButton } from './ChangeOriginButton';
import { ItineraryItemCard } from './ItineraryItemCard';
import styles from './ItineraryTimeline.module.css';
import type { ItineraryTimelineGroupProps } from './TripItinerary.types';
import { getItemDayNumber } from './transformItinerary';
export function ItineraryTimelineGroup(t0) {
  const $ = _c(29);
  const {
    group,
    isLastGroup,
    originLocationName,
    isEditable,
    tripId,
    returnLegId,
    cardSection: t1,
    accommodationStaysByItemId
  } = t0;
  const cardSection = t1 === undefined ? "overview" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className={styles.timelineDot} aria-hidden="true" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== group.dayLabel) {
    t3 = <span>{group.dayLabel}</span>;
    $[1] = group.dayLabel;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== group.dateRange) {
    t4 = <span className={styles.timelineDate}>{group.dateRange}</span>;
    $[3] = group.dateRange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <h4 className={styles.timelineHeading}>{t3}{t4}</h4>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isLastGroup) {
    t6 = !isLastGroup && <span className={styles.timelineTrack} aria-hidden="true" />;
    $[8] = isLastGroup;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isEditable || $[11] !== originLocationName || $[12] !== tripId) {
    t7 = originLocationName && isEditable && <ChangeOriginButton originName={originLocationName} tripId={tripId} />;
    $[10] = isEditable;
    $[11] = originLocationName;
    $[12] = tripId;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== accommodationStaysByItemId || $[15] !== cardSection || $[16] !== group || $[17] !== returnLegId || $[18] !== tripId) {
    t8 = group.items.map(item => <ItineraryItemCard key={item.id} item={item} section={cardSection} tripId={tripId} isReturnLeg={returnLegId !== null && item.id === returnLegId} dayNumber={getItemDayNumber(group, item.startDate)} accommodationStay={item.type === "Stay" ? accommodationStaysByItemId?.get(item.stayItemId) : undefined} />);
    $[14] = accommodationStaysByItemId;
    $[15] = cardSection;
    $[16] = group;
    $[17] = returnLegId;
    $[18] = tripId;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <div className={styles.timelineItems}>{t8}</div>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t9) {
    t10 = <div className={styles.timelineContent}>{t7}{t9}</div>;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t5 || $[27] !== t6) {
    t11 = <section className={styles.timelineGroup}>{t2}{t5}{t6}{t10}</section>;
    $[25] = t10;
    $[26] = t5;
    $[27] = t6;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}